module.exports = __webpack_public_path__ + "static/media/sanjay_krishna.76fc0239.png";